import { createContext } from 'react';

import { SPACING } from '@/mui/constants';

export const SIZE_LARGE = 'LARGE';
export const SIZE_STANDARD = 'STANDARD';

export const SIZE_ENUMS = [SIZE_LARGE, SIZE_STANDARD] as const;

export const DESIGN_STANDARD = 'STANDARD';
export const DESIGN_BACKGROUND = 'BACKGROUND';
export const DESIGN_INLINE = 'INLINE';
export const DESIGN_VERTICAL = 'VERTICAL';
export const DESIGN_INLINE_VERTICAL = 'INLINE_VERTICAL';

export const DESIGN_ENUMS = [
  DESIGN_STANDARD,
  DESIGN_BACKGROUND,
  DESIGN_INLINE,
  DESIGN_VERTICAL,
  DESIGN_INLINE_VERTICAL,
] as const;

export const MOBILE_TYPE_PADDING_DIVIDER = SPACING;
export const DESKTOP_TYPE_PADDING_DIVIDER = SPACING * 2;

export const ChannelContext = createContext({});
